export enum AuthenticationModes {
  GENESYS = 'Genesys',
  BOLD360 = 'Bold360'
}
